import { Stack } from '@festina-life/ui/structure'

import { useUntilChangesetKeyValue } from '../../context/useUntilChangesetKeyValue'
import { getReconciliationSpecOperationFromDate } from '../../uiModels/reconciliationSpecOperations/helpers'
import type { IndexedReconciliationSpecOperationWithMetaData } from '../../uiModels/reconciliationSpecOperations/types'
import { OperationVersionTooltipEntry } from '../versionedTimeline/OperationVersionTooltipEntry'
import { useIsReconciliationSpecVersionActive } from './useIsReconciliationSpecVersionActive'

type Props = {
  versions: IndexedReconciliationSpecOperationWithMetaData[]
}

/**
 * Describes the reconciliation-spec versions sharing a date on the timeline. Versions are
 * selected by changing the view date rather than by navigation, so no link is offered.
 */
export const ReconciliationSpecVersionsTooltipContent = ({
  versions,
}: Props) => {
  const untilChangesetKeyValue = useUntilChangesetKeyValue()
  const isVersionActive = useIsReconciliationSpecVersionActive()

  return (
    <Stack className="flex-col">
      {versions.map((version) => (
        <OperationVersionTooltipEntry
          key={version.internalOperation.operationKey}
          identifier={
            version.internalOperation.reconciliationSpec?.specId ?? '-'
          }
          isActive={isVersionActive(version)}
          isDraft={version.isDraft}
          isInherited={false}
          isLockedToChangeset={
            !!untilChangesetKeyValue &&
            version.changesetHistory?.changesetKey === untilChangesetKeyValue
          }
          fromDate={getReconciliationSpecOperationFromDate(
            version.internalOperation,
          )}
          changesetHistory={version.changesetHistory}
          layer={version.layer}
          block={version.block}
        />
      ))}
    </Stack>
  )
}
